<div class="bank-holiday-alert">
  <ion-grid class="ion-no-margin">
    <ion-row>
      <ion-col class="ion-text-end"
               size="12">
        <ion-icon src="assets/icon/icon-close.svg"
                  class="icon-close"
                  (click)="dismiss()" />
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col class="ion-text-center">
        @if (isBankHoliday) {
          <ion-icon class="support-hours-icon"
                    src="assets/icon/bank-holiday.svg" />
        }
        @if (isOutsideSupportHours) {
          <ion-icon class="support-hours-icon"
                    src="assets/icon/outside-support-hours.svg" />
        }
      </ion-col>
    </ion-row>
    <ion-row>
      @if (isBankHoliday) {
        <ion-col class="ion-text-center mat-card-title">
          {{ 'bank-holiday.alert-header' | translate }}
        </ion-col>
      }
      @if (isOutsideSupportHours) {
        <ion-col class="ion-text-center mat-card-title">
          {{ 'outside-support-hours.alert-header' | translate }}
        </ion-col>
      }
    </ion-row>
    <ion-row>
      <ion-col>
        <app-open-hours/>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col class="ion-text-center">
        <ion-button class="main-btn dismiss-button"
                    size="small"
                    (click)="dismiss()">
          {{ 'bank-holiday.alert-button' | translate }}
        </ion-button>
      </ion-col>
    </ion-row>
  </ion-grid>
</div>